/**
 * Card
 */
import { Component, registerComponent } from 'js/component.js';

const componentName = 'card';

export class Card extends Component {
    elements = {
        stock: this.element.querySelector(`.${componentName}__stock`)
    };

    onStockRequestSuccess(data) {
        // Write the current stock price.
        this.elements.stock.querySelector('.stock-price').innerHTML = `$${data.GetFullStockQuoteListResult[0].TradePrice.toFixed(2)}`;

        // Write the day's stock price change.
        const change = data.GetFullStockQuoteListResult[0].Change;
        this.elements.stock.querySelector('.stock-change').innerHTML = `<div class="${change < 0 ? 'neg' : 'pos'}">${change.toString()}</div>`;

        // Write the date of the stock price.
        const dt = new Date(data.GetFullStockQuoteListResult[0].TradeDate);
        const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][dt.getMonth()];
        const time = dt.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }).replace(/\s+/g, '').toLowerCase();
        this.elements.stock.querySelector('.stock-timestamp').innerHTML = `${month} ${dt.getDate()}, ${dt.getFullYear()} ${time} ET`;
    }

    onStockRequestError() {
        this.elements.stock.querySelector('.stock-quote').remove();
        this.elements.stock.querySelector('.stock-timestamp').innerHTML = 'The stock quote is temporarily unavailable.';
    }

    async requestStockData() {
        try {
            const params = new URLSearchParams({
                exchange: 'XNYS',
                symbol: this.elements.stock.dataset.ticker,
                pageSize: '1'
            });

            const response = await fetch(`https://rockwell2023tf.q4web.com/feed/StockQuote.svc/GetFullStockQuoteList?${params}`);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            this.onStockRequestSuccess(data);
        } catch (error) {
            console.error('Stock request failed:', error);
            this.onStockRequestError();
        }
    }

    /**
     * Initialize Component
     */
    init() {
        if (this.elements.stock) {
            this.requestStockData();
        }
    }
}

registerComponent(`.${componentName}`, Card);